import { useBreadcrumb } from "core/features/breadcrumbs";
import { Flex } from "@chakra-ui/layout";
import { useCurrentTenant } from "features/auth/tenant.store";
import { Button } from "@chakra-ui/react";
import { useMemo } from "react";
import useSaveMultiplesUnidades from "features/unidades/useSaveMultiplesUnidades";
import PageHeader from "components/Page/PageHeader";
import PrimaryButton from "components/Button/PrimaryButton";
import { useRouteMatch } from "react-router-dom";
import history from "infra/helpers/history";
import { ContextMenuGlobal } from "./styles";
import CardDefault from "components/Cards/CardDefault";
import { MdAttachFile } from "react-icons/md";
import { useImportacaoUnidade } from "./hooks";
import TabelaExemplo from "./components/TabelaExemplo";
import TabelaImportacao from "./components/TabelaImportacao";
import ControleImportacao from "./components/ControleImportacao";
import { useInvalidateQuery } from "infra/packages/react-query";
import Container from 'components/Container';

function UnidadeImportacaoPage() {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const route = useRouteMatch<{ tenant: string }>();

  const breadcrumb = useMemo(() => {
    if (route.params.tenant) {
      return [
        {
          name: "Condomínios",
          url: `/condominio`,
        },
        {
          name: "Unidades",
          url: `/condominio/${route.params.tenant}?opcao=unidades`,
        },
        { name: "Importação de Unidades" },
      ];
    }

    return [
      { name: "Unidades", url: "/cadastros/unidades" },
      { name: "Importação de Unidades" },
    ];
  }, [route.params.tenant]);

  useBreadcrumb(breadcrumb);

  const { tenant } = useCurrentTenant();

  const { mutate: handleSave, isLoading } = useSaveMultiplesUnidades(
    route.params.tenant || tenant.id
  );

  const {
    data,
    handleProccessError,
    handleProccess,
    onRowDelete,
    onRowInsertAbove,
    onRowInsertBelow,
    setData,
  } = useImportacaoUnidade();

  const handleProcessSave = () => {
    handleSave(data, {
      onSuccess: () => {
        if (route.params.tenant) {
          history.push(`/condominio/${route.params.tenant}?tab=unidades`);
        } else {
          history.push(`/cadastros/unidades`);
        }
        doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
      },
      onError: (err: any) => {
        handleProccessError(err);
      },
    });
  };

  return (
    <Container>
      <ContextMenuGlobal />

      <Flex>
        <Flex>
          <PageHeader title="Importação de unidades" />
        </Flex>

        <Flex gap="16px" flex={1} justifyContent="flex-end">
          <Button
            as="a"
            isDisabled={isLoading}
            download
            href="https://octopus-assets.s3.amazonaws.com/importacao-unidade.xlsx"
            bg="green.400"
            color="white"
            _hover={{
              bg: "green.600",
              color: "white",
            }}
          >
            <MdAttachFile /> Baixar modelo de planilha
          </Button>

          <PrimaryButton
            isLoading={isLoading}
            isDisabled={isLoading || !data.length}
            onClick={() => {
              handleProcessSave();
            }}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      </Flex>

      <ControleImportacao
        handleProccess={handleProccess}
        setData={setData}
        data={data}
      />

      {data.length ? (
        <TabelaImportacao
          data={data}
          onRowDelete={onRowDelete}
          onRowInsertAbove={onRowInsertAbove}
          onRowInsertBelow={onRowInsertBelow}
          setData={setData}
        />
      ) : null}

      <CardDefault mt={"16px"}>
        <TabelaExemplo />
      </CardDefault>
    </Container>
  );
}

export default UnidadeImportacaoPage;
